import styled from 'styled-components';
export const BarChartContainer = styled.div`
height: 100%;
width: 34px;
/* background-color: wheat; */
/* max-width: 40px; */
/* border: 1px solid gray; */
max-width: 34px; 

display: flex;
flex-direction: column;
align-items: center;
justify-content: flex-end;
/* @media (min-width: 1920px) {

  } */
  span{
    width: 12px;
    height: 17px;
    /* UI Properties */
    text-align: center;
    font: normal normal normal 16px/18px Poppins;
    letter-spacing: 0px;
    color: black;
    opacity: 1;
    font-weight: 900 ;
    margin-top: 6px;
  }




`